<template>
  <el-form
    ref="form"
    :model="formData"
    :rules="rules"
    label-width="110px"
    :size="defaultFormItemSize"
    label-position="right"
    @submit.native.prevent
  >
    <!-- 用户登录用的信息 -->
    <el-card class="box-card" shadow="hover">
      <span style="font-size: 16px; color: #1476c3; font-weight: bold"
        >系统登录用信息</span
      >
      <el-row :gutter="20" class="full-width-input">
        <!-- 左边 -->
        <el-col :span="12">
          <el-form-item label="员工编号" prop="loginName">
            <el-input
              v-model="formData.loginName"
              placeholder="该编号用于登录使用"
              clearable
              :disabled="isEdit"
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="登录密码" v-if="!isEdit" prop="password">
            <el-input
              v-model="formData.password"
              type="password"
              placeholder="用户登录密码"
              clearable
              maxlength="64"
            />
          </el-form-item>
          <el-form-item label="用户角色" prop="roleIdList">
            <el-select v-model="formData.roleIdList" multiple placeholder="用户角色">
              <el-option
                v-for="role in roleList"
                :key="role.roleId"
                :label="role.roleName"
                :value="role.roleId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="账号类型" prop="userType">
            <el-select v-model="formData.userType">
              <el-option
                v-for="item in SysUserType.getList()"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="用户状态" prop="userStatus" v-if="isEdit">
            <el-radio-group v-model="formData.userStatus">
              <el-radio
                v-for="item in SysUserStatus.getList()"
                :key="item.id"
                :label="item.id"
              >
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!-- 右边 -->
        <el-col :span="12">
          <el-form-item label="员工姓名" prop="showName">
            <el-input
              v-model="formData.showName"
              placeholder="员工姓名"
              clearable
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="再次输入密码" v-if="!isEdit" prop="passwordRepeat">
            <el-input
              v-model="formData.passwordRepeat"
              type="password"
              placeholder="再次输入用户密码"
              clearable
              maxlength="64"
            />
          </el-form-item>
          <el-form-item label="数据权限" prop="dataPermIdList">
            <el-select v-model="formData.dataPermIdList" multiple placeholder="数据权限">
              <el-option
                v-for="dataPerm in dataPermList"
                :key="dataPerm.dataPermId"
                :label="dataPerm.dataPermName"
                :value="dataPerm.dataPermId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否可登录" prop="rcAdmin">
            <el-switch
              v-model="formData.rcAdmin"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="0"
              :inactive-value="1"
            >
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-card>

    <!-- 员工信息录入 -->
    <el-card class="box-card" shadow="hover" style="margin-top: 10px">
      <span style="font-size: 16px; color: #1476c3; font-weight: bold"
        >员工信息记录</span
      >
      <el-row :gutter="20" class="full-width-input">
        <!-- 左边 -->
        <el-col :span="12">
          <el-form-item label="性别" prop="userSex">
            <el-select v-model="formData.userSex" placeholder="请选择">
              <el-option :key="0" label="男" :value="0"> </el-option>
              <el-option :key="1" label="女" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学历" prop="userEducation">
            <el-input
              v-model="formData.userEducation"
              placeholder="学历"
              clearable
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="出生日期" prop="userBirthDate">
            <el-date-picker
              v-model="formData.userBirthDate"
              type="date"
              placeholder="选择日期时间"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="身份证号" prop="userIdNo">
            <el-input
              v-model="formData.userIdNo"
              placeholder="身份证号"
              clearable
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="所属部门" prop="deptId">
            <el-cascader
              class="input-item"
              v-model="deptId.value"
              :clearable="true"
              placeholder="所属部门"
              :loading="deptId.impl.loading"
              :props="{
                value: 'deptId',
                label: 'deptName',
                checkStrictly: true,
              }"
              @visible-change="onDeptIdVisibleChange"
              :options="deptId.impl.dropdownList"
              @change="onDeptIdValueChange"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="入职日期" prop="userJoinedDate">
            <el-date-picker
              v-model="formData.userJoinedDate"
              type="date"
              placeholder="选择日期时间"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="工资卡开户行" prop="userBankCardName">
            <el-input
              v-model="formData.userBankCardName"
              placeholder="工资卡开户行"
              clearable
              maxlength="30"
            />
          </el-form-item>
        </el-col>
        <!-- 右边 -->
        <el-col :span="12">
          <el-form-item label="民族" prop="userNation">
            <el-input
              v-model="formData.userNation"
              placeholder="民族"
              clearable
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="联系方式" prop="mobile">
            <el-input
              v-model="formData.mobile"
              placeholder="联系方式"
              clearable
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="婚姻状态" prop="userMarriage">
            <el-input
              v-model="formData.userMarriage"
              placeholder="婚姻状态"
              clearable
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input
              v-model="formData.email"
              placeholder="用户邮箱"
              clearable
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="职务" prop="userDuties">
            <el-input
              v-model="formData.userDuties"
              placeholder="职务"
              clearable
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="转正日期" prop="regularDate">
            <el-date-picker
              v-model="formData.regularDate"
              type="date"
              placeholder="选择日期时间"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="合同结束日期" prop="laborContractEndDate">
            <el-date-picker
              v-model="formData.laborContractEndDate"
              type="date"
              placeholder="选择日期时间"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="工资卡账号" prop="userBankCardNo">
            <el-input
              v-model="formData.userBankCardNo"
              placeholder="工资卡账号"
              clearable
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="社保卡号" prop="userSocialSecurityCardNo">
            <el-input
              v-model="formData.userSocialSecurityCardNo"
              placeholder="社保卡号"
              clearable
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="居住地址" prop="userContactAddress">
            <el-input
              v-model="formData.userContactAddress"
              placeholder="职务"
              clearable
              maxlength="30"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-card>
    <!--相关附件 -->
    <el-card
      class="box-card"
      shadow="hover"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <span style="font-size: 16px; color: #1476c3; font-weight: bold"
        >相关附件</span
      >
      <el-row>
        <el-col :span="24">
          <el-form-item label="用户附件" prop="fileList">
            <el-upload
              class="upload-demo"
              :action="baseUrl + 'qingguang/tenantbussiness/common/upload'"
              ref="upfile"
              name="uploadFile"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :on-exceed="handleExceed"
              :headers="headers"
              :data="{ asImage: false, fieldName: 'userFile' }"
              :file-list="formData.fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">大小不超过20Mb</div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-card>
    <!-- 弹窗下发按钮栏，必须设置class为dialog-btn-layer -->
    <el-row type="flex" justify="end" class="dialog-btn-layer">
      <el-button
        :size="defaultFormItemSize"
        type="primary"
        :plain="true"
        @click="onCancel(false)"
        >取消</el-button
      >
      <el-button
        type="primary"
        :size="defaultFormItemSize"
        @click="onSubmit"
        :disabled="
          !(
            checkPermCodeExist('formSysUser:fragmentSysUser:update') ||
            checkPermCodeExist('formSysUser:fragmentSysUser:add')
          )
        "
      >
        确定
      </el-button>
    </el-row>
  </el-form>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNodePath } from "@/utils";
/* eslint-disable-next-line */
import {
  DropdownWidget,
  TableWidget,
  UploadWidget,
  ChartWidget
} from '@/utils/widget.js';
import { SystemController, SysDeptController, SysDataPermController } from '@/api';
import { uploadMixin } from '@/core/mixins';
import { getToken } from '@/utils';
import { baseUrl } from '@/core/config/development.js';

export default {
  props: {
    rowData: Object
  },
  mixins: [uploadMixin],
  data() {
    return {
      formData: {
        userId: undefined,
        loginName: undefined,
        password: undefined,
        showName: undefined,
        userType: 2,
        userStatus: 0,
        dataPermIdList: [],
        roleIdList: []
      },
      params: {
        userId: undefined,
        loginName: undefined,
        password: undefined,
        showName: undefined,
        deptId: '',
        fileList: [],
        email: '',
        userType: 2,
        mobile: '',
        userBirthDate: '',
        userContactAddress: '',
        userEmail: '',
        userJoinedDate: '',
        userIdNo: '',
        rcAdmin: 0,
        userPhone: '',
        userSex: 0,
        userStatus: 0,
        dataPermIdListString: undefined,
        roleIdListString: undefined
      },
      baseUrl,
      headers: { Authorization: getToken() },
      deptId: {
        impl: new DropdownWidget(this.loadDeptmentDropdownList, true, 'deptId'),
        value: []
      },
      rules: {
        deptId: [{ required: true, message: '所属部门不能为空', trigger: 'change' }],
        loginName: [{ required: true, message: '用户名称不能为空', trigger: 'blur' }],
        password: [{ required: true, message: '用户密码不能为空', trigger: 'blur' }],
        passwordRepeat: [
          { required: true, message: '重输密码不能为空', trigger: 'blur' }
        ],
        showName: [{ required: true, message: '用户昵称不能为空', trigger: 'blur' }],
        dataPermIdList: [
          { required: true, message: '数据权限不能为空', trigger: 'change' }
        ],
        roleIdList: [{ required: true, message: '用户角色不能为空', trigger: 'change' }]
      },
      showHeaderSelect: false,
      dataPermList: [],
      roleList: []
    };
  },
  mounted() {},
  methods: {
    handleRemove(file, fileList) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    /**
     * 所属部门下拉数据获取函数
     */
    loadDeptmentDropdownList() {
      return new Promise((resolve, reject) => {
        let params = {};
        SysDeptController.list(this, params)
          .then((res) => {
            resolve(res.data.dataList);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    /**
     * 所属部门下拉框显隐
     */
    onDeptIdVisibleChange(show) {
      this.deptId.impl.onVisibleChange(show).catch((e) => {});
    },
    /**
     * 所属部门选中值改变
     */
    onDeptIdValueChange(value) {
      this.formData.deptId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    onCancel(isSuccess = false) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (
            this.formData.userId == null &&
            this.formData.password !== this.formData.passwordRepeat
          ) {
            this.$message.error({
              message: '两次密码输入不一致，请重新输入',
              showClose: true
            });
            return;
          }
          var formDatas = JSON.parse(JSON.stringify(this.formData));
          var imgs = this.$refs.upfile.uploadFiles;
          var fileList = [];
          imgs.forEach((it) => {
            if (it.response) {
              fileList.push({
                name: it.name,
                downloadUri: it.response.data.downloadUri,
                filename: it.response.data.filename,
                uploadPath: it.response.data.uploadPath
              });
            }
            if (!it.response) fileList.push(it);
          });
          formDatas.fileList = JSON.stringify(fileList);
          let params = {
            sysUserDto: formDatas,
            dataPermIdListString: Array.isArray(this.formData.dataPermIdList)
              ? this.formData.dataPermIdList.join(',')
              : undefined,
            roleIdListString: Array.isArray(this.formData.roleIdList)
              ? this.formData.roleIdList.join(',')
              : undefined
          };
          let operation = null;
          if (this.formData.userId != null) {
            operation = SystemController.updateUser(this, params);
          } else {
            operation = SystemController.addUser(this, params);
          }

          operation
            .then((res) => {
              this.$message.success(
                this.formData.userId != null ? '编辑成功' : '添加成功'
              );
              this.onCancel(true);
            })
            .catch((e) => {
              //
            });
        }
      });
    },
    loadRole() {
      SystemController.getRoleList(this, {})
        .then((res) => {
          this.roleList = res.data.dataList;
        })
        .catch((e) => {});
    },
    loadDataPerm() {
      SysDataPermController.list(this, {})
        .then((res) => {
          this.dataPermList = res.data.dataList;
        })
        .catch((e) => {});
    },
    loadRowData(id) {
      var params = {
        userId: id
      };
      return SystemController.getUser(this, params);
    }
  },
  computed: {
    isEdit() {
      return this.formData.userId != null;
    }
  },
  mounted() {
    if (!this.rowData) this.rowData = {};
    var rowData = JSON.parse(JSON.stringify(this.rowData));
    if (rowData.fileList) rowData.fileList = JSON.parse(rowData.fileList);
    this.formData = {
      ...this.formData,
      ...rowData,
      dataPermIdList: [],
      roleIdList: []
    };
    if (Array.isArray(this.formData.sysDataPermUserList)) {
      this.formData.dataPermIdList = this.formData.sysDataPermUserList.map(
        (item) => item.dataPermId
      );
    }
    if (Array.isArray(this.formData.sysUserRoleList)) {
      this.formData.roleIdList = this.formData.sysUserRoleList.map((item) => item.roleId);
    }
    this.deptId.impl.onVisibleChange(true).then((res) => {
      this.deptId.value = findTreeNodePath(
        this.deptId.impl.dropdownList,
        this.formData.deptId,
        'deptId'
      );
    });
    this.loadRole();
    this.loadDataPerm();
    this.$nextTick(() => {});
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-switch.sex {
  &::before {
    content: "男";
    display: none;
    color: #fff;
    z-index: 1;
    margin-right: -12px;
    transform: translateX(7px);
    font-size: 12px;
  }

  &::after {
    color: #fff;
    content: "女";
    z-index: 1;
    margin-left: -15px;
    transform: translateX(-4px);
    font-size: 12px;
  }

  &.is-checked::before {
    display: block;
  }

  &.is-checked::after {
    display: none;
  }
}
</style>
